import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";

import { useQuery } from "react-query";

export function useHVSubstationsWithCompanyAndSite(
  customerId?: number,
  companyId?: number,
  siteId?: number,
  getAttributes?: boolean,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["hvSubstationsWithCompanyAndSite", customerId, companyId, siteId, getAttributes],
    queryFn: async () => {
      if (customerId && companyId && siteId)
        return await apiContext.assetApis.getHVSubstationsWithCompanyAndSiteByCustomerAndSite(
          customerId,
          siteId,
          getAttributes,
        );
      else if (customerId && companyId)
        return await apiContext.assetApis.getHVSubstationsWithCompanyAndSiteByCustomerAndCompany(customerId, companyId);
      else if (customerId) return await apiContext.assetApis.getHVSubstationsWithCompanyAndSiteByCustomer(customerId);
    },
  });
}
